import { subscribeToAuction } from "channels/auction_channel";

let endTime;
let timerInterval;

const countdownElement = document.getElementById("countdown");

document.addEventListener("DOMContentLoaded", function() {
  // Get the end time from the server
  const rawEndTime = $("#remaining_time").val();
  endTime = new Date(Date.parse(rawEndTime));

  function updateCountdown() {
    const now = new Date();
    const timeRemaining = endTime - now;

    if (timeRemaining <= 0) {
      document.getElementById('countdown').innerHTML = $("#times_up_label").val();
      clearInterval(timerInterval);
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Format hours, minutes, and seconds to always have two digits
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      var countdown = document.getElementById('countdown')
      var dayLabel = $("#days_translation").val();
      if(countdown){
        countdown.innerHTML =
        `${days} ${dayLabel} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      }
    }
  }

  // Update the countdown every second
  timerInterval = setInterval(updateCountdown, 1000);

  // Initialize countdown display
  updateCountdown();

  const auctionElement = document.getElementById("auction-id");
  if (auctionElement) {
    const auctionId = auctionElement.dataset.auctionId;
    subscribeToAuction(auctionId, (newEndTime) => {
      endTime = new Date(Date.parse(newEndTime));
      updateCountdown();
    });
  
    // Personalize bid table on initial page load
    import('channels/auction_channel').then(module => {
      if (module.personalizeBidTableOnLoad) {
        module.personalizeBidTableOnLoad();
      }
    }).catch(() => {});
  }
});

$(document).ready(function(){

  let ytjLookupTimeout;

  $(document).on("blur", "#user_business_id", function () {
    $("#user_company_name").removeClass("mandatory_field");
    clearTimeout(ytjLookupTimeout);

    const $input = $(this);
    const businessId = $input.val().trim();
    const errorMessage = "Business-id format is wrong";
    const $errorFieldContainer = $("#business-id-error");
    const isValidFormat = /^\d{7}-\d$/.test(businessId);

    $errorFieldContainer.empty(); // Clear previous errors first

    if (businessId === "") return;

    if (!isValidFormat) {
      $errorFieldContainer.append(`<small class="help-block text-red" style="margin-top: -15px;">${errorMessage}</small>`);
      return;
    }

    ytjLookupTimeout = setTimeout(() => {
      fetch(`/ytj_lookup?business_id=${encodeURIComponent(businessId)}`)
        .then(response => {
          if (!response.ok) {
            return response.text().then(text => {
              throw new Error(`Server responded with status ${response.status}: ${text}`);
            });
          }
          return response.json();
        })
        .then(data => {
          $errorFieldContainer.empty();

          if (!data.name || data.name === 'undefined') {
            const notExistMessage = "Business-id does not exist, please check business-id.";
            $errorFieldContainer.append(`<small class="help-block text-red" style="margin-top: -15px;">${notExistMessage}</small>`);
          } else {
            const companyNameInput = document.getElementById('user_company_name');
            const addressInput = document.getElementById('user_address');
            const postalCodeInput = document.getElementById('user_post_number');
            const cityInput = document.getElementById('user_city');

            if (companyNameInput) companyNameInput.value = data.name || '';
            if (addressInput) addressInput.value = data.address || '';
            if (postalCodeInput) postalCodeInput.value = data.post_number || '';
            if (cityInput) cityInput.value = data.city || '';
          }
        })
        .catch(error => {
          console.error('Error fetching company data:', error);
        });
    }, 200); // small debounce for UX
  });

  $(document).on("blur", "#auction_principal_business_id", function () {
    $("#auction_principal_company_name").removeClass("mandatory_field");
    clearTimeout(ytjLookupTimeout);

    const $input = $(this);
    const businessId = $input.val().trim();
    const errorMessage = "Business-id format is wrong";
    const $errorFieldContainer = $("#business-id-error");
    const isValidFormat = /^\d{7}-\d$/.test(businessId);

    $errorFieldContainer.empty(); // Clear previous errors first

    if (businessId === "") return;

    if (!isValidFormat) {
      $errorFieldContainer.append(`<small class="help-block text-red" style="margin-top: -15px;">${errorMessage}</small>`);
      return;
    }

    ytjLookupTimeout = setTimeout(() => {
      fetch(`/ytj_lookup?business_id=${encodeURIComponent(businessId)}`)
        .then(response => {
          if (!response.ok) {
            return response.text().then(text => {
              throw new Error(`Server responded with status ${response.status}: ${text}`);
            });
          }
          return response.json();
        })
        .then(data => {
          $errorFieldContainer.empty();

          if (!data.name || data.name === 'undefined') {
            const notExistMessage = "Business-id does not exist, please check business-id.";
            $errorFieldContainer.append(`<small class="help-block text-red" style="margin-top: -15px;">${notExistMessage}</small>`);
          } else {
            const companyNameInput = document.getElementById('auction_principal_company_name');
            const addressInput = document.getElementById('auction_principal_address');
            const postalCodeInput = document.getElementById('auction_principal_post_number');
            const cityInput = document.getElementById('auction_principal_city');

            if (companyNameInput) companyNameInput.value = data.name || '';
            if (addressInput) addressInput.value = data.address || '';
            if (postalCodeInput) postalCodeInput.value = data.post_number || '';
            if (cityInput) cityInput.value = data.city || '';
          }
        })
        .catch(error => {
          console.error('Error fetching company data:', error);
        });
    }, 200); // small debounce for UX
  });

  $(document).on("click", ".remove-contact-person", function(e) {
    e.preventDefault();
    let target = $(this).data("target");

    // Mark the hidden _destroy field as '1' to indicate deletion
    $(target).find(".hidden-destroy-field").val("1");

    // Hide the contact person row visually
    $(target).hide();
  });

  $(document).on("change", "#auction_start_time_start_hours, #auction_start_time_start_minutes, #post_time_end_hours, #post_time_end_minutes", function(){
    var date1 = $("#auction_auction_date").val();
    var date2 = $("#auction_publication_date").val();
    var hours1 = $("#auction_start_time_start_hours").val();
    var hours2 = $("#post_time_end_hours").val();
    var minutes1 = $("#auction_start_time_start_minutes").val();
    var minutes2 = $("#post_time_end_minutes").val();

    // Convert times to minutes since midnight
    var totalMinutes1 = hours1 * 60 + minutes1;
    var totalMinutes2 = hours2 * 60 + minutes2;

    // Compare the two times
    if ((date1 == date2)) {
      $("#scheduled_date_notice").html("<div class='alert alert-warning alert-dismissible'>Publication start time is not later than end time.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
      $(".save_unfinished_auction_publication_date").addClass("disableattchmentbutton");
      $(".save_auction_publication_date").addClass("disableattchmentbutton");
    } else{
      $("#scheduled_date_notice").html("");
      $(".save_unfinished_auction_publication_date").removeClass("disableattchmentbutton");
      $(".save_auction_publication_date").removeClass("disableattchmentbutton");
    }
  });

  $(document).on("click", ".active_bidder", function(){
    $('.active_bidder').addClass('btn-primary');
    $('.active_seller').removeClass('btn-primary');
    $("#user_role").val("BIDDER");
    $("#customer_type_details").removeClass("hide");
    $( "#company_info" ).addClass( "hide" );
    $( "#basic_info" ).addClass( "hide" );
    $( "#company_other_info" ).addClass( "hide" );
    $( "#private_info" ).removeClass( "hide" );
    $("#user_customer_type").val("PRIVATE");
  });

  $(document).on("click", ".active_seller", function(){
    $('.active_seller').addClass('btn-primary');
    $('.active_bidder').removeClass('btn-primary');
    $("#user_role").val("SELLER");
    $("#user_customer_type").val("COMPANY");
    $("#customer_type_details").addClass("hide");
    $( "#company_info" ).removeClass( "hide" );
    $( "#basic_info" ).removeClass( "hide" );
    $( "#company_other_info" ).removeClass( "hide" );
    $( "#private_info" ).addClass( "hide" );
  });

  $(document).on("click", "#add_new_ad_attachment", function () {
    setDatePicker();
    var other_task = $("#ad_attachments").clone();

    var last_task = $("#existing_ad_attachments .added_ad_attachment_step:last").attr('id');
    if (last_task) {
        var index = parseInt(getId(last_task)) + 1;
    } else {
        var index = 1;
    }

    other_task = other_task.html().replace(/replace_random_id/g, index).replace(/replace_param/g, "ad_attachment_attachment");
    $("#other_ad_attachments").append(other_task);
  });

  // Debounce timer for attachment name updates
  var attachmentNameTimeout;
  
  $(document).on("keyup", ".ad_attachment_name", function () {
    var $input = $(this);
    var auction_id = $("#auction_id").val();
    var id = getId(this.id);
    var attachment_name = $("#ad_attachment_name_"+id).val();
    
    // Clear previous timeout
    clearTimeout(attachmentNameTimeout);
    
    // Store input reference and cursor position for potential focus restoration
    var inputId = this.id;
    var cursorPos = this.selectionStart;
    
    // Set new timeout to debounce the AJAX call
    // This prevents the AJAX call from firing on every keystroke
    attachmentNameTimeout = setTimeout(function() {
      $.ajax({
        url: '/admin/auctions/'+ auction_id +'/update_attachments',
        type: 'GET',
        data: {id: auction_id, attachment_id: id, attachment_name: attachment_name},
        success: function(data, textStatus, xhr) {
          // Check if response is JSON (name-only update) or JavaScript (full re-render)
          var contentType = xhr.getResponseHeader('Content-Type') || '';
          if (contentType.indexOf('application/json') !== -1 || (typeof data === 'object' && data.success)) {
            // JSON response - no DOM update, focus is maintained automatically
            return;
          } else {
            // JavaScript response - DOM was re-rendered, restore focus
            setTimeout(function() {
              var $updatedInput = $('#' + inputId);
              if ($updatedInput.length) {
                $updatedInput.focus();
                // Try to restore cursor position
                if ($updatedInput[0].setSelectionRange) {
                  var newLength = $updatedInput.val().length;
                  var newPos = Math.min(cursorPos, newLength);
                  $updatedInput[0].setSelectionRange(newPos, newPos);
                }
              }
            }, 100);
          }
        }
      });
    }, 500); // Wait 500ms after user stops typing
  });

  $(document).on("click",".remove_ad_attachment", function() {
      var id = getId(this.id);
      $("#parent_element_id_"+ id).remove();
  });

  $('#flash_msg').delay(5000).fadeOut(5000);

  $(document).on('keyup', '.bid_offer',  function() {
    var id = getId(this.id);
    var bid_minimum_price = $("#bid_minimum_price_" + id).val();
    var bid_offer = $("#bid_offer_amount_"+id).val();
    setTimeout(function () {
      if(checkNumericValue(bid_offer) < checkNumericValue(bid_minimum_price)){
        $("#auction_offer_notice_"+id).html("<div class='alert alert-warning alert-dismissible'>we cannot add the value below the Minimum increase set up.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
        $("#bid_offer_button_"+id).addClass("disableattchmentbutton");
      } else {
        $("#auction_offer_notice_"+id).html("");
        $("#bid_offer_button_"+id).removeClass("disableattchmentbutton");
      }
    }, 1000);
  });

  $(document).on('keyup', '#bid_auto_raiser_maximum_price',  function() {
    // Let the formatting handler run first, then do validation
    var $field = $(this);
    var maximum_bid = $field.val();
    var offer_increment_limit = $("#bid_auto_raiser_increment_limit").val();
    var bid_vat_type = $("#vat_rate").val();
    var highest_bid = $("#auction_highest_bid").val();
    var auction_minimum_increase = $("#auction_minimum_increase").val();
    setTimeout(function () {
      if(checkNumericValue(highest_bid) > checkNumericValue(maximum_bid)){
        $("#maximum_auction_notice").html("<div class='alert alert-warning alert-dismissible'>Maximum price must be greater than the current highest offer.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
        $(".set_auto_raiser_btn").addClass("disableattchmentbutton");
      }else{
        $("#maximum_auction_notice").html("");
        $(".set_auto_raiser_btn").removeClass("disableattchmentbutton");
      }
    }, 1000);
    if (bid_vat_type == "0,0"){
      var price_with_vat = checkNumericValue(maximum_bid)
    }else{
      var price_with_vat = checkNumericValue(maximum_bid) * (1 + (checkNumericValue(bid_vat_type) / 100))
    }
    $("#bid_maximum_price").val(checkNumericValue(price_with_vat));

    if(maximum_bid && offer_increment_limit){
      $(".set_auto_raiser_btn").removeClass("disableattchmentbutton");
    }else{
      $(".set_auto_raiser_btn").addClass("disableattchmentbutton");
    }
  });

  $(document).on('keyup', '#bid_auto_raiser_increment_limit',  function() {
    var maximum_bid = $("#bid_auto_raiser_maximum_price").val();
    var offer_increment_limit = $("#bid_auto_raiser_increment_limit").val();
    var bid_vat_type = $("#vat_rate").val();
    var highest_bid = $("#auction_highest_bid").val();
    var auction_minimum_increase = $("#auction_minimum_increase").val();
    var auction_maximum_increase = $("#auction_maximum_increase").val();
    console.log(checkNumericValue(auction_maximum_increase) < checkNumericValue(offer_increment_limit))
    setTimeout(function () {
      if(checkNumericValue(auction_maximum_increase) < checkNumericValue(offer_increment_limit)){
        $("#maximum_increase_notice").html("<div class='alert alert-warning alert-dismissible'>Increment limit must be less than the maximum increase value.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
        $(".set_auto_raiser_btn").addClass("disableattchmentbutton");
      }else{
        $("#maximum_increase_notice").html("");
        $(".set_auto_raiser_btn").removeClass("disableattchmentbutton");
      }

      if(checkNumericValue(auction_minimum_increase) > checkNumericValue(offer_increment_limit)){
        $("#minimum_auction_notice").html("<div class='alert alert-warning alert-dismissible'>Increment limit must be greater than the minimum increase value.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
        $(".set_auto_raiser_btn").addClass("disableattchmentbutton");
      }else{
        $("#minimum_auction_notice").html("");
        $(".set_auto_raiser_btn").removeClass("disableattchmentbutton");
      }
    }, 1000);
    if(maximum_bid && offer_increment_limit){
      $(".set_auto_raiser_btn").removeClass("disableattchmentbutton");
    }else{
      $(".set_auto_raiser_btn").addClass("disableattchmentbutton");
    }
  });


  $(document).on("click", "#basic_info", function(){
    $('.basic_info_check').addClass('active');
    $('.other_offices_check').removeClass('active');
    $( "#basic_info_details" ).removeClass( "hide" )
    $( "#other_office_details" ).addClass( "hide" )
  });

  $(document).on("click", "#other_offices", function(){
    $('.other_offices_check').addClass('active');
    $('.basic_info_check').removeClass('active');
    $( "#basic_info_details" ).addClass( "hide" )
    $( "#other_office_details" ).removeClass( "hide" )
  });

  $(document).on("click", ".show_drop_down_menu", function(){
    var parentEl = $(this).parent().closest('.drop_down_data_list');
    $(parentEl).find('.set_title_name').toggleClass("hide");
    $(parentEl).find('.show_upside_arrow').toggleClass("hide");
    $(parentEl).find('.display_drop_down_data').toggleClass("hide");
  });

  if ($('.pagination').length) {
    $(document).scroll(function() {
      var url = $('.pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.pagination').text("Please Wait...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }

  if ($('.first_pagination').length) {
    $(document).scroll(function() {
      var url = $('.first_pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.first_pagination').text("Please Wait...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }

  if ($('.second_pagination').length) {
    $(document).scroll(function() {
      var url = $('.second_pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.second_pagination').text("Please Wait...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }

  if ($('.third_pagination').length) {
    $(document).scroll(function() {
      var url = $('.third_pagination .next_page').attr('href');
      if (url && $(document).scrollTop() > $(document).height() - $(document).height() - 50) {
        $('.third_pagination').text("Please Wait...");
        return $.getScript(url);
      }
    });
    return $(document).scroll();
  }

  $(document).on("click", ".show_detail_drop_down_menu", function(){
    var parentEl = $(this).parent().closest('.drop_down_data_list');
    var contractor_type = $(parentEl).find('.set_title_name').siblings(".hide").text().replace(/\n/g, '');
    if (contractor_type == "SUB CONTRACTOR"){
      $("#project_contractor_type").val(1);
    }else{
      $("#project_contractor_type").val(0);
    }
    $(parentEl).find('.set_title_name').toggleClass("hide");
    $(parentEl).find('.show_upside_arrow').toggleClass("hide");
    $(parentEl).find('.show_drop_down_data').toggleClass("hide");
    $(parentEl).find(".show_detail_drop_down_menu").toggleClass("up-arrow");
    $(parentEl).find(".show_detail_drop_down_menu").toggleClass("down-arrow");
  });

  $(document).on("click", ".openCloseDetails", function(){
    var toggle_id = $(this).data('show_modal_id');
    $(this).parent().parent().find("#"+toggle_id).toggleClass("hide");
    $(this).find(".show_selected_detail_arrow").toggleClass("hide");
  });

  $(document).on('focusout', ".addThousandSeparators", function() {
    var value = $(this).val();
    // If empty, leave it empty
    if (!value || value.trim() === '') {
      return;
    }
    // Allow ,00 format but block other decimal values
    if (value.includes(',')) {
      if (!value.match(/,00$/)) {
        // If it contains comma but doesn't end with ,00, remove the decimal part
        value = value.replace(/,.*$/, '');
      }
    }
    var formatted = addThousandSeparators(value);
    if (formatted) {
      $(this).val(formatted);
    }
  });

  // Format fields when modal is shown (for dynamically loaded content)
  $(document).on('shown.bs.modal', '.modal', function() {
    var $modal = $(this);
    // Use setTimeout to ensure content is fully rendered
    setTimeout(function() {
      $modal.find('.addThousandSeparators').each(function() {
        var $this = $(this);
        var value = $this.val();
        if (value) {
          // Remove spaces first to get raw value
          var rawValue = value.replace(/\s/g, '');
          var formatted = addThousandSeparators(rawValue);
          if (formatted && formatted !== value) {
            $this.val(formatted);
            // Trigger input event to ensure other handlers see the formatted value
            $this.trigger('input');
          }
        }
      });
    }, 100);
  });

  // Allow comma only for ,00 format in price fields
  $(document).on('keypress', ".addThousandSeparators", function(e) {
    // Block period (46) but allow comma (44) for ,00 format
    if (e.which == 46) {
      e.preventDefault();
      return false;
    }
    // Allow comma, but validate the full input on keyup
  });

  // Format with thousand separators and validate ,00 format on keyup/input
  $(document).on('keyup input', ".addThousandSeparators", function(e) {
    var $this = $(this);
    var value = $this.val();
    
    // Skip if empty
    if (!value || value.trim() === '') {
      return;
    }
    
    // Save cursor position based on number of digits before cursor
    var cursorPos = this.selectionStart;
    var textBeforeCursor = value.substring(0, cursorPos);
    var digitsBeforeCursor = (textBeforeCursor.match(/\d/g) || []).length;
    
    // Remove existing spaces (thousand separators) to get raw number
    var rawValue = value.replace(/\s/g, '');
    
    // Validate ,00 format if comma is present
    if (rawValue.includes(',')) {
      // If user is typing after comma, only allow 00
      var parts = rawValue.split(',');
      if (parts.length > 1 && parts[1].length > 0) {
        // Replace any non-zero digits after comma with 0
        var decimalPart = parts[1].replace(/[^0]/g, '0').substring(0, 2);
        rawValue = parts[0] + ',' + decimalPart;
      }
    }
    
    // Format with thousand separators
    var formatted = addThousandSeparators(rawValue);
    
    // Always update to ensure formatting is applied (even if value looks the same)
    // This handles cases where the value might have been set programmatically
    if (formatted && formatted !== value) {
      $this.val(formatted);
      
      // Restore cursor position based on number of digits before cursor
      var newText = formatted;
      var digitCount = 0;
      var newCursorPos = 0;
      
      for (var i = 0; i < newText.length; i++) {
        if (/\d/.test(newText[i])) {
          digitCount++;
          if (digitCount === digitsBeforeCursor) {
            newCursorPos = i + 1;
            break;
          }
        }
      }
      
      // If we didn't find the exact position, place at end or before comma if applicable
      if (newCursorPos === 0) {
        newCursorPos = formatted.length;
      }
      
      // Only set cursor position if this is a user input event (not programmatic)
      if (e && e.type === 'input' || e.type === 'keyup') {
        this.setSelectionRange(newCursorPos, newCursorPos);
      }
    }
  });

  $("#presentation_text").on('keyup',function(){
    $(this).css('height','auto');
    $(this).height(this.scrollHeight);
  })

  common_events();

  $(document).on("change", ".check_feedback_phase_attachment_type", function(){
    var phase_type = $(this).val();
    $('.attach_current_page_location').addClass('hide');
    $('.attach_feedback_resources').addClass('hide');
    if (phase_type == "YES"){
      $('.attach_current_page_location').removeClass('hide');
    }else{
      $('.attach_feedback_resources').removeClass('hide');
    }
  });

  $(document).on("change", ".copy_same", function(){
    $('.' + $(this).data('class_name')).val($(this).val());
    if ($(this).data('trigger_class_name')){
      $('.' + $(this).data('trigger_class_name')).trigger('change');
    }
  });

  $(document).on("click", ".unclickable", function(){
    return false;;
  });

  $(document).on("change", ".checkFile", function(){
    var reader = new FileReader();
    var fileField = $(this);
    var file = $(fileField)[0].files[0];

    reader.onload = function() {
      dataUrl = reader.result;
      checkFileIcon = $(fileField).closest('.checkFileParent').find('.checkFileIcon');
      $(checkFileIcon).removeClass('hide');
      var checkLink = $(checkFileIcon).find('a');
      $(checkLink).attr('download', file.name);
      $(checkLink).attr('href', dataUrl);
    }

    if (file) {
      reader.readAsDataURL(file);
    }
  });
  
  $(document).on("click", ".hard_return_back", function(){
    redirectTo(window.location.href);
  });

  $(document).on("click", ".make_request", function(){
    var url = $(this).data('request_url');
    var method_type = $(this).data('method_type');
    var t;
    clearTimeout(t);
    t = setTimeout(function () {
      $.ajax({
        url: url,
        type: method_type
      });
    }, 100);
  });

  $(document).on("change", ".media-file-upload", function(){
    var id = getId(this.id);
    var reader = new FileReader();
    var parentEl = $(this).closest('.file_attachments');
    var ele = $(parentEl).find('.preview_attachments');

    if ($(parentEl).find(".saved_media_file").length > 0){
      $(parentEl).find(".destroy-media-file").val("0");
    }
    removePreviewFileEle = "<a class='remove-file remove-media-file dib' href='javascript:void(0);'><div class='remove-preview-file remove'><i class='fa fa-times'></i></div></a>";

    preview_file_ele = "<li class='form-group'><a href='javascript:void(0);'>" + this.files.item(0).name + "</a> " + removePreviewFileEle + "</li>";
    $(ele).find("li").addClass("hide");
    $(ele).append(preview_file_ele);
  });

  $(document).on("click", ".remove-media-file", function(){
    var parentEl = $(this).closest('.file_attachments');
    $(parentEl).find(".media-file-upload").val('');
    if ($(parentEl).find(".saved_media_file").length > 0){
      $(parentEl).find(".destroy-media-file").val("1");
    }
    $(parentEl).find("li").addClass("hide");
  });

  $(document).on('click', '.checkMandatory', function(e){
    // Prevent submission if button is disabled or has disableattchmentbutton class
    if ($(this).hasClass('disableattchmentbutton') || $(this).prop('disabled')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    
    var form = $(this).closest('form');
    var mandatory_fields = $(form).find('.mandatory_field')
    var isValid = checkIfAllFieldsHaveValues(mandatory_fields);
    if (!isValid){
      e.preventDefault();
      $(mandatory_fields).each(function() {
        custom_validation(this);
      });
      $(form).find(".has-error").find('input').focus();
      $('#loader-image').hide();
    }
  });

  $(document).on("change keyup select input", ".mandatory_field", function(){
    custom_validation(this);
    // Also trigger button validation when mandatory fields change (universal)
    var form = $(this).closest('form');
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 100);
  });

  // Handle select2 change events for mandatory fields - multiple events to catch all cases
  $(document).on('select2:select select2:unselect select2:clear select2:close', '.select2.mandatory_field', function() {
    custom_validation(this);
    var form = $(this).closest('form');
    // Run validation immediately and after delays
    validateAndToggleButtons(form);
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 50);
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 200);
    // Also trigger step1 validation if it exists
    if (typeof window.checkStep1Fields === 'function') {
      setTimeout(window.checkStep1Fields, 50);
    }
  });
  
  // Also listen to native change event on select2 fields
  $(document).on('change', '.select2.mandatory_field', function() {
    custom_validation(this);
    var form = $(this).closest('form');
    setTimeout(function() {
      validateAndToggleButtons(form);
      if (typeof window.checkStep1Fields === 'function') {
        window.checkStep1Fields();
      }
    }, 100);
  });

  // Handle rich text editor changes (Trix editor)
  $(document).on('trix-change trix-initialize', 'trix-editor.mandatory_field, .form-control-editor.mandatory_field', function() {
    custom_validation(this);
    var form = $(this).closest('form');
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 100);
  });
  
  // Also handle input events on rich text editors
  $(document).on('input', '.form-control-editor.mandatory_field, trix-editor.mandatory_field', function() {
    custom_validation(this);
    var form = $(this).closest('form');
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 100);
  });

  // Validate on page load and disable buttons initially (universal for all steps)
  $(document).ready(function() {
    // Small delay to ensure all dynamic content is loaded (select2, rich text editors, etc.)
    setTimeout(function() {
      $('form').each(function() {
        // Ensure datepicker fields trigger validation
        var form = $(this);
        form.find('.datepicker').on('changeDate', function() {
          setTimeout(function() {
            validateAndToggleButtons(form);
          }, 100);
        });
        
        // Universal validation for all forms
        validateAndToggleButtons(form);
      });
    }, 500);
  });
  
  // Also validate when DOM is fully ready (universal for all steps)
  // This ensures select2 and other plugins are initialized
  $(function() {
    setTimeout(function() {
      $('form').each(function() {
        validateAndToggleButtons($(this));
      });
    }, 1000);
    
    // Additional validation after a longer delay to catch late-loading plugins
    setTimeout(function() {
      $('form').each(function() {
        validateAndToggleButtons($(this));
      });
    }, 1500);
  });
  
  // Expose validation function globally for manual triggering
  window.validateFormButtons = function() {
    $('form').each(function() {
      validateAndToggleButtons($(this));
    });
  };
  
  
  // Validate after select2 is initialized
  $(document).on('select2:select select2:unselect select2:clear', '.select2.mandatory_field', function() {
    var form = $(this).closest('form');
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 100);
  });
  
  // Also validate when select2 is opened (in case values changed externally)
  $(document).on('select2:open', '.select2.mandatory_field', function() {
    var form = $(this).closest('form');
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 50);
  });


  // Function to format time inputs with leading zeros
  function formatTimeInput(input) {
    var value = $(input).val();
    if (value !== '' && value !== null) {
      var numValue = parseInt(value, 10);
      if (!isNaN(numValue) && numValue >= 0) {
        $(input).val(('0' + numValue).slice(-2));
      }
    }
  }

  // Apply formatting to all time inputs (hour and minute fields)
  // Handles both display time fields and auction start time fields
  // Format on blur and change events
  $(document).on('blur change', 'input[name*="[start_hour]"], input[name*="[start_minute]"], input[name*="[end_hour]"], input[name*="[end_minute]"], input[name*="[hours]"], input[name*="[minutes]"]', function() {
    // Skip readonly fields as they're already formatted
    if (!$(this).prop('readonly')) {
      formatTimeInput(this);
    }
  });

  // Handle arrow keys (up/down) for immediate formatting
  $(document).on('keyup', 'input[name*="[start_hour]"], input[name*="[start_minute]"], input[name*="[end_hour]"], input[name*="[end_minute]"], input[name*="[hours]"], input[name*="[minutes]"]', function(e) {
    // Skip readonly fields as they're already formatted
    if (!$(this).prop('readonly')) {
      // Format immediately on arrow keys (up/down) - keyCode 38 = up, 40 = down
      if (e.keyCode === 38 || e.keyCode === 40) {
        // Use setTimeout to format after the browser's default increment/decrement
        var self = this;
        setTimeout(function() {
          formatTimeInput(self);
        }, 0);
      }
    }
  });

  // Handle input event to format immediately when value changes (catches arrow keys and typing)
  $(document).on('input', 'input[type="number"][name*="[start_hour]"], input[type="number"][name*="[start_minute]"], input[type="number"][name*="[end_hour]"], input[type="number"][name*="[end_minute]"], input[type="number"][name*="[hours]"], input[type="number"][name*="[minutes]"]', function() {
    if (!$(this).prop('readonly')) {
      var value = $(this).val();
      // Format if value is a valid number (works for both arrow keys and typing)
      if (value !== '' && value !== null && value !== undefined) {
        var numValue = parseInt(value, 10);
        if (!isNaN(numValue) && numValue >= 0) {
          // Format with leading zero immediately (00, 01, 02, 03, etc.)
          $(this).val(('0' + numValue).slice(-2));
        }
      }
    }
  });

  // Format existing time inputs on page load
  $(function() {
    $('input[name*="[start_hour]"], input[name*="[start_minute]"], input[name*="[end_hour]"], input[name*="[end_minute]"], input[name*="[hours]"], input[name*="[minutes]"]').each(function() {
      // Skip readonly fields as they're already formatted
      if (!$(this).prop('readonly')) {
        formatTimeInput(this);
      }
    });
  });

  $('#display_time_info').on('cocoon:after-insert', function(e, ad_display_time) {
    var new_index  =$(ad_display_time).find('.display_date').attr('id').split('auction_ad_display_times_attributes_')[1].split('_display_date')[0];
    
    // Re-initialize datepicker for the new display_date field
    var locale = document.documentElement.lang || 'en';
    ad_display_time.find('.display_date').datepicker({
      format: 'dd.mm.yyyy',
      autoclose: true,
      todayBtn: 'linked',
      todayHighlight: true,
      orientation: 'bottom',
      weekStart: 1,
      language: locale,
      startDate: '0d'
    });

    // Add change handlers to all display time fields in the new entry
    ad_display_time.find('.mandatory_field').on('change keyup input', function() {
      custom_validation(this);
    });

    // Format time inputs with leading zeros on blur
    ad_display_time.find('input[name*="[start_hour]"], input[name*="[start_minute]"], input[name*="[end_hour]"], input[name*="[end_minute]"]').on('blur change', function() {
      formatTimeInput(this);
    });

    // Handle display_date change - CRITICAL: This triggers validation when date is selected after times
    var displayDateField = ad_display_time.find('.display_date');
    displayDateField.on('changeDate', function(e) {
      var form = $(this).closest('form');
      // Multiple validations with increasing delays to catch the change
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 50);
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 150);
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 300);
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 600);
    });

    // Also listen to native change event
    displayDateField.on('change', function() {
      var form = $(this).closest('form');
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 100);
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 300);
    });

    ad_display_time.find('.display_end_time').change(function() {
      var start_time = $("#auction_ad_display_times_attributes_" + new_index + '_start_hour').val();
      var end_time = $("#auction_ad_display_times_attributes_" + new_index + '_end_hour').val();
      st = minFromMidnight(start_time);
      et = minFromMidnight(end_time);
      var form = $(this).closest('form');
      if(start_time > end_time){
        $("#auction_display_date_notice").html("<div class='alert alert-warning alert-dismissible'>End time must be bigger then Start time<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
        $(".checkMandatory").addClass("disableattchmentbutton");
      }else{
        $(".checkMandatory").removeClass("disableattchmentbutton");
        $("#auction_display_date_notice").html("");
      }
      // Always validate after time change
      validateAndToggleButtons(form);
    });

    // Validate after inserting new display time
    var form = ad_display_time.closest('form');
    validateAndToggleButtons(form);
  });

  // Handle removal of display time entries
  $('#display_time_info').on('cocoon:after-remove', function(e, ad_display_time) {
    var form = $(this).closest('form');
    validateAndToggleButtons(form);
  });

  // Handle display_date changes for existing display time entries (when date is selected after times)
  $(document).on('changeDate', '#display_time_info .display_date', function(e) {
    var form = $(this).closest('form');
    var self = this;
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 50);
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 150);
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 300);
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 600);
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 1000);
  });
  
  // Also listen to native change event
  $(document).on('change', '#display_time_info .display_date', function() {
    var form = $(this).closest('form');
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 100);
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 300);
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 600);
  });
  
  // Add polling mechanism specifically for display_date fields when times are already filled
  // This ensures validation runs even if events don't fire properly
  setInterval(function() {
    var displayTimeSection = $('#display_time_info');
    if (displayTimeSection.length > 0 && !displayTimeSection.hasClass('hide')) {
      displayTimeSection.find('.nested-fields').each(function() {
        var displayTime = $(this);
        var displayDate = displayTime.find('.display_date').val() || '';
        var startHour = displayTime.find('input[name*="[start_hour]"]').val();
        var startMinute = displayTime.find('input[name*="[start_minute]"]').val();
        var endHour = displayTime.find('input[name*="[end_hour]"]').val();
        var endMinute = displayTime.find('input[name*="[end_minute]"]').val();
        
        // Check if times are filled but date was just added
        var timesFilled = startHour && startMinute && endHour && endMinute;
        var dateFilled = displayDate && displayDate.trim() !== '';
        
        // If times are filled and date is now filled, trigger validation
        if (timesFilled && dateFilled) {
          var form = displayTime.closest('form');
          if (form.length > 0) {
            validateAndToggleButtons(form);
          }
        }
      });
    }
  }, 500);

  // Handle display time section visibility changes
  $(document).on('change', 'input[name="auction[confirm_display_times]"]', function() {
    var form = $(this).closest('form');
    setTimeout(function() {
      validateAndToggleButtons(form);
    }, 100);
  });

  // scroll listing
  $('.scroll').jscroll({
    loadingHtml: '<img src="/assets/loader-small.gif" alt="Loading" />',
    autoTrigger: true,
    padding: 20,
    nextSelector: 'a.jscroll-next:last',
    callback: common_events
  });

  // open remax email modal
  $(document).on('input propertychange paste click', '#user_email',  function() {
    userEmail = $(this).val();
    if (validateEmail(userEmail)) {
      $("#remaxEmailbtn").attr('disabled', false);
    }else{
      $("#remaxEmailbtn").attr('disabled', true);
    }
  })

  if ($("#user_email").val() != ""){
    $("#remaxEmailbtn").attr('disabled', false);
  }

  $(document).on('click', '#remaxEmailbtn',  function() {
    userVal = $('#user_email').val();
    msgText = $("#old_message").val();
    msgText = msgText.replace("userEmail", userVal);
    msgText = msgText.replace(/^\s+|\s+$/gm,'');
    $("#message").html(msgText);
  })

  if ($("#steps").length > 0){
    var total_step = $("#steps").find($("input")).length/2 + 3;
    $(document).on("click", "#add_new_step",  function() {
      var count = ++total_step;
      $('#input_add_step').append('<div class="added_step" id="added_step_wrapper_' + count + '"><div class="row row7"><div class="col-12 col-sm-3 form-group pt-md-2">STEP '+ count +' </div><div class="col-12 col-sm-4 form-group"><input type="text" id="input_add_year_'+count+'" name="setting[step_'+ count +'][year]" class="form-control" placeholder = "Year"/></div><div class="col-12 col-sm-4 form-group"><input type="text" id="input_add_days_'+count+'" name="setting[step_'+ count +'][days]" class="form-control" placeholder = "days"/></div><div class="col-12 col-sm-1 pt-md-2 form-group"><a href="javascript:void(0)" class="addLink remove_fields dynamic remove_step" id="remove_step_' + count + '"><i class="removeIcon"></i>Remove</a></div></div></div>')
    });
    $(document).on("click",".remove_step", function() {
      var idArr = this.id.split("_");
      var id = idArr[idArr.length - 1];
      $("#added_step_wrapper_"+ id).remove();
    });
  }

  if ($("#price_steps").length > 0){
    // Find the actual highest tier number from existing price steps
    var total_step = 0;
    $('.added_price_step').each(function() {
      var id = $(this).attr('id');
      if (id && id.includes('added_price_step_wrapper_')) {
        var tierId = parseInt(id.split('_').pop());
        if (!isNaN(tierId) && tierId > total_step) {
          total_step = tierId;
        }
      }
    });
    
    // Initialize: hide all delete buttons except the highest tier
    $('.remove_price_step_div, [id^="remove_price_step_div_"]').addClass('hide');
    if (total_step > 0) {
      $("#remove_price_step_div_" + total_step).removeClass('hide');
    }
    
    $(document).on("click", "#add_new_price_step",  function(e) {
      e.preventDefault(); // Prevent any default link behavior
      
      // Hide all existing delete buttons
      $('.remove_price_step_div, [id^="remove_price_step_div_"]').addClass("hide");
      
      if(total_step == 0){
        var min_price = 0;
      }else{
        var min_price = $("#input_add_max_price_"+total_step).val();
      }
      var count = ++total_step;
      $('#input_add_price_step').append('<div class="added_price_step" id="added_price_step_wrapper_' + count + '"> <div class="row row7 pt-3"> <div class="col-12 text-18 fw-bold">PRICE STEP '+ count +'</div> <div class="col-12 col-sm-4 mb-3"><div class="inputOuterText"> <input type="text" id="input_add_min_price_'+count+'" name="price_list[price_'+ count +'][min_selling_price]" value="' + min_price + '" class="form-control addThousandSeparators text-center" placeholder="VAT FREE ITEM SELLING PRICE[MIN.]"/> <div class="textIconOuter">EUR</div></div></div> <div class="col-12 col-sm-4 mb-3"><div class="inputOuterText"> <input type="text" id="input_add_max_price_'+count+'" name="price_list[price_'+ count +'][max_selling_price]" class="form-control addThousandSeparators text-center" placeholder="VAT FREE ITEM SELLING PRICE[MAX.]"/><div class="textIconOuter">EUR</div></div></div> <div class="col-12 col-sm-4 mb-3"><div class="inputOuterText"> <input type="text" id="input_add_ad_price_'+count+'" name="price_list[price_'+ count +'][ad_price]" class="form-control addThousandSeparators text-center" placeholder="AD PRICE[VAT 0%]"/><div class="textIconOuter">EUR</div></div></div></div><div class="row"><div class="col-12 col-sm-9"></div><div class="col-12 col-sm-3 mb-3 text-end remove_price_step_div" id="remove_price_step_div_' + count + '"> <button type="button" class="btn btn-md btn-dark remove_price_step" id="remove_price_step_' + count + '">DELETE TIER</button></div></div> </div>');
      
      return false; // Prevent any default behavior
    });
          $(document).on("click",".remove_price_step", function(e) {
        e.preventDefault(); // Prevent form submission
        
        var wrapper = $(this).closest(".added_price_step");
        var stepId = this.id.split("_").pop();
        var destroyField = $("#destroy_price_step_" + stepId);
        
        if (destroyField.length > 0) {
          destroyField.val("1");
          wrapper.hide();
        } else {
          wrapper.remove();
        }
      
      // Find the highest remaining visible tier and show its delete button
      var highestTier = 0;
      $('.added_price_step:visible').each(function() {
        var id = $(this).attr('id');
        if (id && id.includes('added_price_step_wrapper_')) {
          var tierId = parseInt(id.split('_').pop());
          if (!isNaN(tierId) && tierId > highestTier) {
            highestTier = tierId;
          }
        }
      });
      
      // Hide all delete buttons first
      $('.remove_price_step_div, [id^="remove_price_step_div_"]').addClass('hide');
      
      // Show delete button on the highest remaining tier
      if (highestTier > 0) {
        $("#remove_price_step_div_" + highestTier).removeClass('hide');
      }
      
              // Update total_step to reflect current state
        total_step = highestTier;
        
        // Submit form data via AJAX for immediate database update
        var form = $(this).closest('form');
        if (form.length > 0) {
          // Get all form data including the destroy fields
          var formData = new FormData(form[0]);
          
          fetch(form.attr('action'), {
            method: 'PUT',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            redirect: 'manual' // Don't follow redirects
          })
          .then(function(response) {
            console.log('Price tier deleted successfully from database');
            return response;
          })
          .catch(function(error) {
            console.log('Price tier updated (redirect handled)');
          });
        }
        return false;
      });
    }

  // order email
  $(function(){
    var remaxrecipient = $('#input_remax_recipient');
    // var count = $('#input_remax_recipient p').size();
    $(document).on("click", "#add_recipient_for_remax_email",  function() {
      $('<p><input type="email" id="recipient_email" name="recipient_email['+ count +']" class="form-control"/><a href="#" id="removeremaxinput">Remove</a></p>').appendTo(remaxrecipient);
      count++;
      return false;
    });
    $(document).on("click","#removeremaxinput", function() {
      if( count > 1 )
        {
          $(this).parents('p').remove();
          count--;
        }
      return false;
    });
  });

  // check for valid hours, minutes
  $(document).on( 'change', ".time_hour",function(){
    if (!($(this).val() >= parseInt("00") && $(this).val() <= 23)){
      $(this).val("");
    }
  });

  $(document).on( 'change', ".time_minute",function(){
    if (!($(this).val() >= parseInt("00") && $(this).val() <= 59)){
      $(this).val("");
    }
  });

  $(document).ready(function () {
    setTimeout(function () {
      $(".stepBtnSticky").css('height', $('.stepBtnSticky').height());
      $(".stepBtnSticky").css('position', 'sticky');
    }, 500);  
  });
  
  $(document).ready(function () {
    setTimeout(function () {
      $(".stepBtnStickymanage").css('height', $(window).height());
      $(".stepBtnStickymanage").css('position', 'sticky');
    }, 500);
  });

  $(document).on('click', '.auction_offer_button',  function() {
    if ($(this).hasClass('disableattchmentbutton') || $(this).data('submitting')) {
      return false;
    }
    
    var auction_offer = $("#auction_offer").val();
    var highest_ad_bid = $("#highest_ad_bid").val();
    var minimum_price = $("#minimum_price").val();
    var maximum_price = $("#maximum_price").val();
    var verify_identification_status = $("#verify_identification_status").val();
    var auction_id = $("#auction_id").val();
    var user_id = $("#user_id").val();

    var auctionOfferNumeric = checkNumericValue(auction_offer);
    var highestAdBidNumeric = checkNumericValue(highest_ad_bid);
    var minimumPriceNumeric = checkNumericValue(minimum_price);
    var maximumPriceNumeric = checkNumericValue(maximum_price);

    if(auctionOfferNumeric < highestAdBidNumeric){
      $("#ad_offer_notice").html("<div class='alert alert-warning alert-dismissible'>Highest bid for this offer is "+highest_ad_bid+". You cannot add less than that.<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
      $(".auction_offer_button").addClass("disableattchmentbutton");
      return false;
    }
    
    var minimumRequired = highestAdBidNumeric + minimumPriceNumeric;
    if(auctionOfferNumeric < minimumRequired){
      $("#ad_offer_notice").html("<div class='alert alert-warning alert-dismissible'>MINIMUM INCREASE IS <b>"+minimum_price+" EUR</b><button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
      $(".auction_offer_button").addClass("disableattchmentbutton");
      return false;
    }
    
    var maximumAllowed = highestAdBidNumeric + maximumPriceNumeric;
    if(auctionOfferNumeric > maximumAllowed){
      $("#ad_offer_notice").html("<div class='alert alert-warning alert-dismissible'>MAXIMUM INCREASE IS <b>"+maximum_price+" EUR</b><button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>")
      $(".auction_offer_button").addClass("disableattchmentbutton");
      return false;
    }
    
    if(verify_identification_status == false){
      $(".auction_offer_button").addClass("disableattchmentbutton");
      return false;
    }

    $(this).data('submitting', true);
    $("#ad_offer_notice").html("");
    $("#auction_offer_button").addClass("disableattchmentbutton");
    
    setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/save_an_offer',
        type: 'POST',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
          offer: {
            auction_id: auction_id,
            offer_amount: auction_offer,
            user_id: user_id
          }
        },
        success: function(data) {
          window.location.reload();
        },
        error: function(xhr) {
          $("#loader-image").hide();
          $(".auction_offer_button").removeClass("disableattchmentbutton").removeData('submitting');
          window.location.reload();
        }
      });
    }, 500);
    
    return false;
  });

  // Handle Add to Watch List link click
  $(document).on('click', '.link-watch-list', function(e) {
    var $link = $(this);
    var href = $link.attr('href');
    
    // Only handle if not already in wishlist
    if (!$link.hasClass('in-wishlist')) {
      e.preventDefault();
      
      // Make AJAX call to add to wishlist
      $.ajax({
        url: href,
        type: 'GET',
        dataType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        success: function(data) {
          if (data.success) {
            // Update the link to show filled star
            $link.addClass('in-wishlist');
            var $svg = $link.find('svg use');
            var currentHref = $svg.attr('xlink:href') || $svg.attr('href');
            var newHref = currentHref.replace('#icon-star', '#icon-star-filled');
            $svg.attr('xlink:href', newHref);
            $svg.attr('href', newHref);
            
            // Set color to pink
            $link.css('color', '#D30074');
          }
          
          // Open wishlist page in new tab
          window.open(href, '_blank');
        },
        error: function() {
          // If AJAX fails, just open the link normally
          window.open(href, '_blank');
        }
      });
    } else {
      // If already in wishlist, just open in new tab
      e.preventDefault();
      window.open(href, '_blank');
    }
  });
  
});

function minFromMidnight(tm){
  var ampm= tm.substr(-2)
  var clk = tm.substr(0, 5);
  var m  = parseInt(clk.match(/\d+$/)[0], 10);
  var h  = parseInt(clk.match(/^\d+/)[0], 10);
  h += (ampm.match(/pm/i))? 12: 0;
  return h*60+m;
}

// Global function to validate all mandatory fields and enable/disable buttons
function validateAndToggleButtons(form) {
  if (!form || form.length === 0) {
    form = $('form');
  }

  var mandatory_fields = $(form).find('.mandatory_field:visible');
  var isValid = true;
  var invalidFields = [];
  
  // Also check for specific step 1 fields by name as fallback
  var step1Fields = {
    text: $(form).find('input[name*="[text]"], input[name="auction[text]"], input#auction_text'),
    body: $(form).find('textarea[name*="[body]"], textarea[name="auction[body]"], textarea.form-control-editor, trix-editor'),
    keywords: $(form).find('select[name*="[confirm_keywords]"], select[name="auction[confirm_keywords]"], select.select2.mandatory_field')
  };
  
  // If we're in step 1 and have these fields, also validate them directly
  if (step1Fields.text.length > 0 || step1Fields.body.length > 0 || step1Fields.keywords.length > 0) {
    // Check text field
    if (step1Fields.text.length > 0 && step1Fields.text.is(':visible') && !step1Fields.text.prop('disabled')) {
      var textValue = step1Fields.text.val();
      if (!textValue || textValue.toString().trim() === '') {
        isValid = false;
        invalidFields.push('text');
      }
    }
    
    // Check body field (rich text editor)
    if (step1Fields.body.length > 0 && step1Fields.body.is(':visible') && !step1Fields.body.prop('disabled')) {
      var bodyContent = '';
      // Try multiple ways to get body content
      if (step1Fields.body.is('trix-editor')) {
        try {
          if (step1Fields.body[0] && step1Fields.body[0].editor) {
            bodyContent = step1Fields.body[0].editor.getDocument().toString();
          }
        } catch(e) {}
      } else {
        bodyContent = step1Fields.body.val() || '';
      }
      // Check for hidden input (Trix stores content here)
      var bodyHidden = $(form).find('input[type="hidden"][name*="[body]"], input[type="hidden"][name="auction[body]"]');
      if (bodyHidden.length > 0) {
        bodyContent = bodyHidden.val() || bodyContent;
      }
      // Also check for trix-editor element
      var trixEditor = $(form).find('trix-editor');
      if (trixEditor.length > 0) {
        try {
          if (trixEditor[0] && trixEditor[0].editor) {
            var trixContent = trixEditor[0].editor.getDocument().toString();
            if (trixContent && trixContent.trim() !== '') {
              bodyContent = trixContent;
            }
          }
        } catch(e) {
          // Ignore errors
        }
      }
      var bodyText = $('<div>').html(bodyContent).text().trim();
      if (bodyText === '' || bodyText === null) {
        isValid = false;
        invalidFields.push('body');
      }
    }
    
    // Check keywords field (select2)
    if (step1Fields.keywords.length > 0 && step1Fields.keywords.is(':visible') && !step1Fields.keywords.prop('disabled')) {
      var keywordsValue = step1Fields.keywords.val();
      if (!keywordsValue || 
          (Array.isArray(keywordsValue) && keywordsValue.length === 0) || 
          keywordsValue === null || 
          keywordsValue === '') {
        isValid = false;
        invalidFields.push('keywords');
      }
    }
  }

  // Check all visible mandatory fields
  $(mandatory_fields).each(function() {
    var field = $(this);
    var value = field.val();

    // Skip disabled or readonly fields - IMPORTANT for step 3 "Immediately" option
    if (field.prop('disabled') || field.prop('readonly')) {
      return; // Skip this field, don't mark as invalid
    }
    
    // Special handling for step 3: publication_date_and_time field when "Immediately" is selected
    // This field is disabled but has mandatory_field class, so we skip it
    if (field.attr('name') === 'auction[publication_date_and_time]' && field.prop('disabled')) {
      return; // Skip this field
    }

    // Handle select2 fields (multi-select)
    if (field.hasClass('select2')) {
      // For select2, check if any option is selected
      // Select2 stores values in the original select element
      var select2Value = field.val();
      
      // If select2 is initialized, try to get data directly
      try {
        if (field.data('select2')) {
          var select2Data = field.select2('data');
          if (select2Data && select2Data.length > 0) {
            // Has selections, so it's valid
            return; // Skip further validation for select2
          }
        }
      } catch(e) {
        // If select2 method fails, fall back to val()
      }
      
      // Check the value directly
      if (!select2Value || 
          (Array.isArray(select2Value) && select2Value.length === 0) || 
          select2Value === null || 
          select2Value === '' ||
          (typeof select2Value === 'string' && select2Value.trim() === '')) {
        isValid = false;
        invalidFields.push(field.attr('name') || 'select2_field');
        return false; // break the loop
      }
      return; // Skip further validation for select2
    }

    // Handle rich text editor fields (ActionText/Trix)
    if (field.hasClass('form-control-editor') || field.is('trix-editor')) {
      var editorContent = '';
      var fieldName = field.attr('name') || '';
      
      // For Trix editor, get content from the editor element or hidden input
      if (field.is('trix-editor')) {
        // Trix editor content - try to get from editor API
        try {
          if (field[0] && field[0].editor) {
            editorContent = field[0].editor.getDocument().toString();
          }
        } catch(e) {
          // Fall back to hidden input
        }
        // Also try to get from associated hidden input
        var trixInput = field.siblings('input[type="hidden"]');
        if (trixInput.length > 0) {
          editorContent = trixInput.val() || editorContent;
        }
      } else if (field.is('textarea')) {
        // Try to get value from the field itself
        editorContent = field.val() || '';
        
        // Check for associated hidden input (ActionText/Trix pattern)
        var hiddenInput = field.siblings('input[type="hidden"]');
        if (hiddenInput.length > 0) {
          editorContent = hiddenInput.val() || editorContent;
        }
        
        // Also check for trix-input specifically by name pattern
        if (fieldName && fieldName.includes('[body]')) {
          var trixInputByName = $('input[type="hidden"][name="' + fieldName + '"]');
          if (trixInputByName.length > 0) {
            editorContent = trixInputByName.val() || editorContent;
          }
        }
        
        // Check if there's a trix-editor element nearby (same parent)
        var trixEditor = field.siblings('trix-editor');
        if (trixEditor.length > 0) {
          try {
            if (trixEditor[0] && trixEditor[0].editor) {
              var trixContent = trixEditor[0].editor.getDocument().toString();
              if (trixContent && trixContent.trim() !== '') {
                editorContent = trixContent;
              }
            }
          } catch(e) {
            // Ignore errors
          }
        }
      } else {
        editorContent = field.val() || '';
      }
      
      // If still empty, try to find by name attribute directly
      if ((!editorContent || editorContent.trim() === '') && fieldName) {
        var directInput = $('input[type="hidden"][name="' + fieldName + '"]');
        if (directInput.length > 0) {
          editorContent = directInput.val() || '';
        }
      }
      
      // Remove HTML tags and check if there's actual text content
      var textContent = $('<div>').html(editorContent).text().trim();
      // Also check if it's just empty HTML like <div><br></div> or <p><br></p>
      var cleanHtml = editorContent.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
      
      if ((textContent === '' || textContent === null) && (cleanHtml === '' || cleanHtml === null)) {
        isValid = false;
        invalidFields.push(field.attr('name') || 'rich_text_editor');
        return false; // break the loop
      }
      return; // Skip further validation for rich text editor
    }

    // Handle number fields - check if value is empty or just placeholder
    if (field.attr('type') === 'number') {
      // For number fields, check if value is empty, null, undefined, or placeholder
      // Number fields can have values like 0, 1, 2, etc., which are valid
      if (value === '' || value === null || value === undefined || value === 'HH' || value === 'MM') {
        isValid = false;
        invalidFields.push(field.attr('name') || field.attr('id') || 'number_field');
        return false; // break the loop
      }
      // Check if it's a valid number (including 0)
      var numValue = parseFloat(value);
      if (isNaN(numValue) && value !== '0' && value !== 0) {
        isValid = false;
        invalidFields.push(field.attr('name') || field.attr('id') || 'number_field');
        return false; // break the loop
      }
    } else {
      value = value ? value.toString().trim() : '';
      if (value === '' || value === 'HH' || value === 'MM') {
        isValid = false;
        invalidFields.push(field.attr('name') || field.attr('id') || 'text_field');
        return false; // break the loop
      }
    }
  });

  // Check if display time section is visible and has display times
  var displayTimeSection = $('#display_time_info');
  if (displayTimeSection.length > 0 && !displayTimeSection.hasClass('hide')) {
    // Check each display time entry
    var hasDisplayTimes = displayTimeSection.find('.nested-fields').length > 0;
    if (hasDisplayTimes) {
      displayTimeSection.find('.nested-fields').each(function() {
        var displayTime = $(this);
        var displayDate = displayTime.find('.display_date').val() || '';
        var startHour = displayTime.find('input[name*="[start_hour]"]').val();
        var startMinute = displayTime.find('input[name*="[start_minute]"]').val();
        var endHour = displayTime.find('input[name*="[end_hour]"]').val();
        var endMinute = displayTime.find('input[name*="[end_minute]"]').val();

        // Convert to strings and clean up
        displayDate = displayDate ? displayDate.toString().trim() : '';

        // Handle number fields properly - they can be 0, 1, 2, etc.
        // IMPORTANT: Check for null/undefined/empty string, but NOT for 0 (which is a valid value)
        startHour = (startHour !== null && startHour !== undefined && startHour !== '') ? startHour.toString().trim() : '';
        startMinute = (startMinute !== null && startMinute !== undefined && startMinute !== '') ? startMinute.toString().trim() : '';
        endHour = (endHour !== null && endHour !== undefined && endHour !== '') ? endHour.toString().trim() : '';
        endMinute = (endMinute !== null && endMinute !== undefined && endMinute !== '') ? endMinute.toString().trim() : '';

        // Remove placeholder values
        if (startHour === 'HH') startHour = '';
        if (startMinute === 'MM') startMinute = '';
        if (endHour === 'HH') endHour = '';
        if (endMinute === 'MM') endMinute = '';

        // Check if numeric values are valid (including 0)
        // A value is valid if it's not empty and is a valid number (including 0)
        var startHourValid = startHour !== '' && startHour !== 'HH' && !isNaN(parseFloat(startHour)) && isFinite(startHour);
        var startMinuteValid = startMinute !== '' && startMinute !== 'MM' && !isNaN(parseFloat(startMinute)) && isFinite(startMinute);
        var endHourValid = endHour !== '' && endHour !== 'HH' && !isNaN(parseFloat(endHour)) && isFinite(endHour);
        var endMinuteValid = endMinute !== '' && endMinute !== 'MM' && !isNaN(parseFloat(endMinute)) && isFinite(endMinute);

        // If any field is filled, all must be filled
        if (displayDate || startHourValid || startMinuteValid || endHourValid || endMinuteValid) {
          if (!displayDate || !startHourValid || !startMinuteValid || !endHourValid || !endMinuteValid) {
            isValid = false;
            return false; // break the loop
          }
        }
      });
    }
  }

  // Check for validation errors - but only if they're actually invalid
  // Remove has-error class from fields that are now valid
  $(form).find(".has-error").each(function() {
    var errorContainer = $(this);
    var field = errorContainer.find('.mandatory_field');
    if (field.length > 0) {
      var value = field.val();
      var isNumberField = field.attr('type') === 'number';

      // Check if field is now valid
      var isNowValid = false;
      if (isNumberField) {
        // For number fields, check if it's a valid number (including 0)
        // IMPORTANT: 0 is a valid value, so check explicitly for empty/null/undefined
        if (value !== '' && value !== null && value !== undefined && value !== 'HH' && value !== 'MM') {
          var valueStr = value.toString().trim();
          if (valueStr !== '' && valueStr !== 'HH' && valueStr !== 'MM') {
            var numValue = parseFloat(valueStr);
            isNowValid = !isNaN(numValue) && isFinite(numValue);
          }
        }
      } else {
        value = value ? value.toString().trim() : '';
        isNowValid = (value !== '' && value !== 'HH' && value !== 'MM');
      }

      if (isNowValid) {
        // Remove error class and validation messages
        errorContainer.removeClass('has-error');
        errorContainer.find('small.help-block.text-red').remove();
        errorContainer.find('i.form-control-feedback').remove();
      }
    }
  });

  // Check for remaining validation errors AFTER cleanup
  var hasErrors = $(form).find(".has-error").length > 0;
  
  // Check for time validation errors (end time must be > start time)
  if ($("#auction_display_date_notice").find('.alert-warning').length > 0) {
    isValid = false;
  }
  
  // Check for date validation alert warnings in notice divs (universal check)
  var hasDateValidationErrors = false;
  // Check all possible notice divs that might contain validation errors
  var noticeSelectors = [
    "#auction_publication_date_notice",
    "#scheduled_date_notice", 
    "#auction_notice_publication_date_notice",
    "#auction_notice_auction_date_notice",
    "#auction_minimum_maximum_increase_notice"
  ];
  
  noticeSelectors.forEach(function(selector) {
    if ($(selector).find('.alert-warning').length > 0) {
      hasDateValidationErrors = true;
    }
  });
  
  // Check if buttons have disableattchmentbutton class (from other validation)
  var hasDisableClass = $(form).find("button.checkMandatory").hasClass("disableattchmentbutton");
  
  // Special handling for step 1: if all step 1 fields are filled, enable buttons
  var isStep1 = step1Fields.text.length > 0 || step1Fields.body.length > 0 || step1Fields.keywords.length > 0;
  var step1AllFilled = true;
  var step1FieldStatus = { text: false, body: false, keywords: false };
  
  if (isStep1) {
    // Check text field
    if (step1Fields.text.length > 0 && step1Fields.text.is(':visible') && !step1Fields.text.prop('disabled')) {
      var textVal = step1Fields.text.val();
      if (textVal && textVal.toString().trim() !== '') {
        step1FieldStatus.text = true;
      } else {
        step1AllFilled = false;
      }
    } else if (step1Fields.text.length === 0) {
      // Field not found, skip this check
      step1FieldStatus.text = true;
    }
    
    // Check body field
    if (step1Fields.body.length > 0 && step1Fields.body.is(':visible') && !step1Fields.body.prop('disabled')) {
      var bodyVal = '';
      // Try trix-editor first
      var trixEditor = $(form).find('trix-editor');
      if (trixEditor.length > 0) {
        try {
          if (trixEditor[0] && trixEditor[0].editor) {
            bodyVal = trixEditor[0].editor.getDocument().toString();
          }
        } catch(e) {}
      }
      // Try textarea
      if (!bodyVal && step1Fields.body.is('textarea')) {
        bodyVal = step1Fields.body.val() || '';
      }
      // Try hidden input
      if (!bodyVal) {
        var bodyHidden = $(form).find('input[type="hidden"][name*="[body]"], input[type="hidden"][name="auction[body]"]');
        if (bodyHidden.length > 0) {
          bodyVal = bodyHidden.val() || '';
        }
      }
      var bodyText = $('<div>').html(bodyVal).text().trim();
      if (bodyText && bodyText !== '') {
        step1FieldStatus.body = true;
      } else {
        step1AllFilled = false;
      }
    } else if (step1Fields.body.length === 0) {
      // Field not found, skip this check
      step1FieldStatus.body = true;
    }
    
    // Check keywords field
    if (step1Fields.keywords.length > 0 && step1Fields.keywords.is(':visible') && !step1Fields.keywords.prop('disabled')) {
      var keywordsVal = step1Fields.keywords.val();
      // Also try select2 data API
      try {
        if (step1Fields.keywords.data('select2')) {
          var select2Data = step1Fields.keywords.select2('data');
          if (select2Data && select2Data.length > 0) {
            keywordsVal = select2Data.map(function(item) { return item.id; });
          }
        }
      } catch(e) {}
      
      if (keywordsVal && 
          !(Array.isArray(keywordsVal) && keywordsVal.length === 0) && 
          keywordsVal !== null && 
          keywordsVal !== '') {
        step1FieldStatus.keywords = true;
      } else {
        step1AllFilled = false;
      }
    } else if (step1Fields.keywords.length === 0) {
      // Field not found, skip this check
      step1FieldStatus.keywords = true;
    }
    
    // If all step 1 fields are filled, force enable buttons
    if (step1AllFilled && step1FieldStatus.text && step1FieldStatus.body && step1FieldStatus.keywords) {
      isValid = true;
      hasErrors = false;
      hasDisableClass = false;
      hasDateValidationErrors = false;
      // Remove disable class from all buttons
      $(form).find("button.checkMandatory").removeClass("disableattchmentbutton");
      // Force enable buttons
      $(form).find("button.checkMandatory[type='submit']").prop('disabled', false).removeClass('disabled');
    }
  }
  
  // Special check for step 1 form - if all fields filled, always enable
  // DO THIS FIRST before other validation to prevent disabling
  var formId = form.attr('id');
  var isStep1Form = (formId === 'ad-form-1');
  var step1AllFieldsFilled = false;
  
  if (isStep1Form) {
    // Direct check of step 1 fields
    var textField = form.find('input[name="auction[text]"]');
    var textVal = textField.val() || '';
    var textOk = textVal.trim() !== '';
    
    var bodyOk = false;
    var trixEditor = form.find('trix-editor');
    if (trixEditor.length > 0 && trixEditor[0] && trixEditor[0].editor) {
      try {
        var trixContent = trixEditor[0].editor.getDocument().toString();
        var trixText = $('<div>').html(trixContent).text().trim();
        bodyOk = trixText !== '';
      } catch(e) {}
    }
    if (!bodyOk) {
      var bodyHidden = form.find('input[type="hidden"][name="auction[body]"]');
      if (bodyHidden.length > 0) {
        var bodyContent = bodyHidden.val() || '';
        var bodyText = $('<div>').html(bodyContent).text().trim();
        bodyOk = bodyText !== '';
      }
    }
    
    var keywordsOk = false;
    var keywordsField = form.find('select[name="auction[confirm_keywords]"]');
    if (keywordsField.length > 0) {
      // Method 1: Check select2 container DOM for visible tags (MOST RELIABLE)
      var select2Container = keywordsField.next('.select2-container');
      if (select2Container.length > 0) {
        var choiceTags = select2Container.find('.select2-selection__choice');
        if (choiceTags.length > 0) {
          keywordsOk = true;
        }
      }
      
      // Method 2: Check val()
      if (!keywordsOk) {
        var keywordsVal = keywordsField.val();
        if (Array.isArray(keywordsVal) && keywordsVal.length > 0) {
          keywordsOk = true;
        } else if (keywordsVal && keywordsVal !== '' && keywordsVal !== null) {
          keywordsOk = true;
        }
      }
      
      // Method 3: Check select2 data API
      if (!keywordsOk && keywordsField.data('select2')) {
        try {
          var select2Data = keywordsField.select2('data');
          if (select2Data && select2Data.length > 0) {
            keywordsOk = true;
          }
        } catch(e) {}
      }
      
      // Method 4: Check selected options in DOM
      if (!keywordsOk) {
        var selectedOptions = keywordsField.find('option:selected');
        if (selectedOptions.length > 0 && selectedOptions.filter(function() { 
          return $(this).val() !== '' && $(this).val() !== null; 
        }).length > 0) {
          keywordsOk = true;
        }
      }
    }
    
    step1AllFieldsFilled = textOk && bodyOk && keywordsOk;
  }
  
  // Universal validation: disable buttons if invalid, has errors, or has disable class
  // BUT: if step 1 fields are all filled, override and enable buttons
  var forceEnable = false;
  if (isStep1 && step1AllFilled && step1FieldStatus.text && step1FieldStatus.body && step1FieldStatus.keywords) {
    forceEnable = true;
  }
  if (isStep1Form && step1AllFieldsFilled) {
    forceEnable = true;
  }
  
  $(form).find("button.checkMandatory[type='submit']").each(function() {
    var button = $(this);
    
    // SPECIAL HANDLING FOR STEP 1 ONLY: Check if step1 validation says all fields are filled
    // Only run this for step 1 form (ad-form-1), not for step 3 (auction-form)
    if (isStep1Form && formId === 'ad-form-1' && typeof window.checkStep1Fields === 'function') {
      // Run step1 validation first
      var step1Result = window.checkStep1Fields();
      if (step1Result) {
        // Step1 validation passed - FORCE ENABLE
        button.prop('disabled', false);
        button.removeClass('disabled');
        button.removeClass('disableattchmentbutton');
        button.css({
          'pointer-events': 'auto',
          'opacity': '1',
          'cursor': 'pointer'
        });
        return; // Skip other validation
      }
    }
    
    if (forceEnable || (isStep1Form && step1AllFieldsFilled)) {
      // Force enable for step 1 when all fields are filled
      button.prop('disabled', false);
      button.removeClass('disabled');
      button.removeClass('disableattchmentbutton');
    } else if (!isValid || hasErrors || hasDisableClass || hasDateValidationErrors) {
      // Only disable if NOT step1 form OR step1 validation failed
      if (!isStep1Form || (typeof window.checkStep1Fields === 'function' && !window.checkStep1Fields())) {
        // For step 3, check if step3 validation says it's OK
        var isStep3Form = (formId === 'auction-form');
        var shouldDisable = true;
        
        if (isStep3Form && typeof window.validateStep3 === 'function') {
          // Run step3 validation to check if buttons should be enabled
          var step3Result = window.validateStep3();
          if (step3Result) {
            // Step3 validation passed - enable buttons
            button.prop('disabled', false);
            button.removeClass('disabled');
            button.removeClass('disableattchmentbutton');
            return; // Skip disabling
          }
        }
        
        // For step 3 "Immediately" case, check if only issue is disabled field
        if (isStep3Form) {
          var immediateSelected = $('#immediate_sale_ad').is(':checked');
          if (immediateSelected && invalidFields.length > 0) {
            // Check if the only invalid field is the disabled publication_date_and_time
            var onlyDisabledField = invalidFields.length === 1 && 
              invalidFields[0] && 
              invalidFields[0].indexOf('publication_date_and_time') !== -1;
            if (onlyDisabledField && !hasDateValidationErrors && !hasErrors) {
              shouldDisable = false; // Don't disable, the field is intentionally disabled
            }
          }
        }
        
        if (shouldDisable) {
          button.prop('disabled', true);
          button.addClass('disabled');
        }
      }
    } else {
      button.prop('disabled', false);
      button.removeClass('disabled');
      // Also remove disableattchmentbutton class if validation passes
      button.removeClass('disableattchmentbutton');
    }
  });
}

// Make validateAndToggleButtons globally available
window.validateAndToggleButtons = validateAndToggleButtons;

function custom_validation(element){
  var form = $(element).closest('form');
  var value = $(element).val();

  // Handle number fields - check if value is empty or just placeholder
  if ($(element).attr('type') === 'number') {
    value = value === '' || value === null || value === undefined ? '' : value.toString().trim();
  } else {
    value = value ? value.toString().trim() : '';
  }

  if (value.length > 0 && value !== 'HH' && value !== 'MM'){
    remove_validation_text(element);
    $(element).parent().closest('div').removeClass('has-error');
  }
  else{
   var required = $("#required").val();
   $(element).parent().closest('div').addClass('has-error');
   $(element).parent().closest('div').css("position", "relative");
   $(element).parent().closest('div').find('small:eq(0)').remove();
   $(element).parent().closest('div').find('i:eq(0)').remove();
   $(element).parent().closest('div').append('<i class="form-control-feedback fa fa-remove" style="top: 0px; right: 5px;"></i>'); 
   $(element).parent().closest('div').append('<small class="help-block text-red">'+ required +'</small>');
  }

  // Use the new validation function to toggle buttons
  validateAndToggleButtons(form);
}

function addThousandSeparators(nStr) {
  // Handle null, undefined, or empty string
  if (!nStr || nStr === '' || nStr === null || nStr === undefined) {
    return '';
  }
  
  nStr += '';
  // Remove all non-digit and non-comma characters
  nStr = nStr.replace(/[^\d,]/g, '');
  
  // If empty after cleaning, return empty
  if (!nStr || nStr === '') {
    return '';
  }
  
  // Check if it ends with ,00 to preserve that format
  var hasValidDecimal = nStr.match(/,00$/);
  var x = nStr.split(',');
  var x1 = x[0];
  var x2 = ',00'; // Always add ,00 by default
  
  // Handle decimal part if comma is present
  if (nStr.includes(',')) {
    if (hasValidDecimal) {
      x2 = ',00';
    } else if (x[1]) {
      // Limit to 2 decimal places
      var decimalPart = x[1].replace(/[^0]/g, '0').substring(0, 2);
      x2 = ',' + decimalPart;
    } else {
      x2 = ',00';
    }
  }
  
  // Format thousands with spaces (only if there are digits)
  if (x1 && x1 !== '') {
    // Remove any existing spaces first
    x1 = x1.replace(/\s/g, '');
    // Format from right to left, adding space every 3 digits
    var rgx = /\B(?=(\d{3})+(?!\d))/g;
    x1 = x1.replace(rgx, ' ');
  } else {
    // If no integer part, return empty (don't show just ",00")
    return '';
  }
  
  return x1 + x2;
}

function setScrollPosition(selectedId) {
  $('html,body').animate({scrollTop: ($("#" + selectedId).offset().top - 2) }, 'slow');
}

function slideContent(slideFrom){
  if ($("#open_card_form").val() != 'true') {
    $('#mainWrapper').show('slide', { direction : slideFrom}, 1000);
  }
}

function fadeOutFlashMessage(id){
  $("#" + id).delay(3000).fadeOut(500);
}

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}

function setFlashMessage(parentId, flashId, msg, fadeOut, animate){
  $("#" + parentId).html(getFlashMessageEle(msg, flashId));
  if (animate != false){
    SetFocusOnTopOfPage()
    //$('html, body').animate({scrollTop:$('#' + parentId).position().top}, 'slow');
  }
  if (fadeOut != false) {
    fadeOutFlashMessage(flashId);
  }
}

function getFlashMessageEle(msg, flashId){
  return "<div id='" + flashId + "' class='alert alert-success alert-dismissible' role='alert'>" + msg + "<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>"
}

function common_events(){
  $( '#filterFormId' ).on( 'change', 'select', function(){
    $("#loader-image").show();
    // $( '#filterFormId' ).submit();
    $( '#filter_save_button' ).click();
  });

  $(document).on('change', '.filter_check_box', function(){
    $("#loader-image").show();
    $(this).closest('form').submit();
  });

  $('.fileUploadMedia').on( 'change', function(){
    if (this.files && this.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        $('.preview_file_box').html('<img src='+e.target.result+'>');
      }
      reader.readAsDataURL(this.files[0]);
    }
  });

  if ($("#pc_browser").val() != 'true') {
    $('.virtualKeyboard').attr('readonly', true);
  }

  $("#flash_msg").delay(3000).fadeOut(500);

  $(".filter-btn-cls, #filter-btn, #saveMedia, #saveMediaNext").click(function(){
    $("#loader-image").show();
  });
  
  $(document).on("click", ".pre-icon-load", function(){
    $(".pre-icon").show();
  });

  $(document).on("click", ".pre-icon-load-remote", function(){
    $(".pre-icon").show();
  });

  $(document).on("submit", ".pre-load-form", function(){
    $(".pre-icon").show();
  });

  $(document).on("click", ".navbar-toggle", function(){
    $(this).toggleClass('active');
    $('.navbar-collapse').toggleClass('active');
    $('.menuOverlay').toggleClass('active');
  });
  $(document).on("click", ".menuOverlay", function(){
    $(this).removeClass('active');
    $('.navbar-collapse').toggleClass('active');
    $('.navbar-toggle').toggleClass('active');
  });

  $(document).on('change', '.media_file', function(e){
    var parentEl = $(this).closest('.parent');
    $.each(this.files, function() {
      showMediaFilename(this, parentEl);
    });
  });
}

function showMediaFilename(file, parentEl){
  var reader = new FileReader();
  reader.onload = function(e) {
    $(parentEl).find('.media_attachment_name').val(file.name);
  }
  reader.readAsDataURL(file);
}

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function showFilename(file, ele) {
  var reader = new FileReader();
  reader.onload = function(e) {
    $(ele).val(file.name);
  }
  reader.readAsDataURL(file);
}

function redirectTo(url, params){
  $.each(params, function(index, value){
    url = url + value;
  });
  window.location.replace(url);
}

function checkIfAllFieldsHaveValues(elements) {
  var isValid = true;
  $(elements).each(function() {
    if ( !$(this).prop('disabled') && !$(this).prop('readonly') && $(this).val() === '' )
      isValid = false;
  });
  return isValid;
}

function SetFocusOnTopOfPage(){
  $(".modal").animate({ scrollTop: 0 }, "slow");
}

function isInArray(value, array) {
  return array.indexOf(value) > -1;
}

function checkIfAllFieldsHaveUniqueValues(elements) {
  var isValid;
  var values = [];
  $(elements).each(function() {
    if ( $(this).val() != '' ) {
      values.push($(this).val())
      var check_valid = true;
      for (i=0; i<values.length; i++) {
        for (j=i+1; j<values.length; j++) {
          if (values[i]==values[j]) {
            isValid = false;
            var first_ele = $(elements)[i];
            var second_ele = $(elements)[j];
            custom_uniquness_validation(first_ele, second_ele);
            check_valid = false;
            break;
          }
        }
      }
      if (check_valid){
        var class_name = $(this).attr("data-unique");
        $('.'+class_name).parent().closest('div').removeClass('has-error');
        $('.'+class_name).parent().closest('div').find('small:eq(0)').remove();
        $('.'+class_name).parent().closest('div').find('i:eq(0)').remove();
      }
    }
  });
  return isValid;
}

function isAnyModalOpen() {
  return $('.modal.in').length > 0;
}

function display_validation_text(element,msg){
  $(element).parent().closest('div').addClass('has-error');
  $(element).parent().closest('div').find('small:eq(0)').remove();
  $(element).parent().closest('div').find('i:eq(0)').remove();
  $(element).parent().closest('div').append('<i class="form-control-feedback fa fa-remove" style="top: 0px;"></i>'); 
  $(element).parent().closest('div').append('<small class="help-block">'+msg+'</small>');
}

function remove_validation_text(element){
  $(element).parent().closest('div').removeClass('has-error');
  $(element).parent().closest('div').find('small:eq(0)').remove();
  $(element).parent().closest('div').find('i:eq(0)').remove();
}

function checkIfSumEqualToOne(elements){
  var isValid = true;
  var total_fraction = 0;
  $(elements).each(function() {
    var fraction = $(this).val();
    if (fraction.match('/') != null){
      var split = fraction.split('/');
      var result = parseInt(split[0], 10) / parseInt(split[1], 10);
      total_fraction += parseFloat(result)
    }else{
      total_fraction += (parseFloat(fraction))
    }
  });
  if (total_fraction == 1) {
    isValid = true;
  }
  else{
    isValid = false; 
  }
  return isValid;
}

function checkIfPerSumEqualToOne(elements){
  var isValid = true;
  var total_percentage = 0;
  $(elements).each(function() {
    if ( $(this).val() != '' ) {
      total_percentage += parseFloat($(this).val())
    }
  });
  if (total_percentage == 100) {
    isValid = true;
  }
  else{
    isValid = false; 
  }
  return isValid;
}

function checkIsNaNVal(val){
  val = (isNaN(val)) ? 0 : val;
  return val;
}

function checkNumericValue(number, decimal_points = 2) {
  if (number){    
    return parseFloat(parseFloat(number.toString().replace(' ', '').replace(",", ".")).toFixed(decimal_points));
  }
  else{
    return 0;
  }
}

function show_formatted_number(number, decimal_points = 2, with_space = true){
  if (number || number === 0){
    number = checkNumericValue(number, decimal_points);
    var parts = number.toString().split(".");
    if (with_space){
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
    return parts.join(",");
  }
  else{
    return "0,00";
  }
}

function commonAddOrRemoveHideClass(check_object, match_value, type){
  var parentEl = $(check_object).closest(".parent_hide_show_class");
  var childEl = $(parentEl).find(".child_hide_show_class");
  if ($(check_object).val() == match_value){
    if (type == "hide_fields"){
      $(childEl).removeClass("hide");
    }
    if (type == "disable_fields"){
      $(childEl).find('input').attr("disabled", false);
    }
  }
  else{
    if (type == "hide_fields"){
      $(childEl).addClass("hide");
    }
    if (type == "disable_fields"){
      $(childEl).find('input').attr("disabled", true);
      $(childEl).find('input').val("");
    }
  }
}

function modify_next_elements(){
  var elements = $(".jscroll-inner")
  $(elements).each(function() {
    var added = $(this).find('.jscroll-added')
    $(this).append($(added).children('.col-12'))
    $(added).children('.col-12').remove()
    $(this).append($(added))
  });
}

if ($(".remove_fields").length == 1){
  $(".remove_fields").addClass("hide");
  }
else if ($(".remove_fields").length >= 1){
  var remove_fields  = document.getElementsByClassName("remove_fields")
  remove_fields[0].className = remove_fields[0].className.replace(/\bremove_fields\b/g, "remove_fields hide")
  }
else{
  if ($(".remove_fields").hasClass("hide")){
  ($(".remove_fields").removeClass("hide"));
  }
}

$(function() {
  $("#imageListId").sortable({
    update: function(event, ui) {
      getIdsOfImages();
    } //end update
  });
});

function getIdsOfImages() {
  var auction_id = $("#auction_id").val();
  var values = [];
  $('.listitemClass').each(function(index) {
    values.push($(this).attr("id").replace("imageNo", ""));
  });

  $.ajax({
    url: '/admin/auctions/'+ auction_id +'/reorder_auction_images',
    type: 'GET',
    data: {id: auction_id, child_ids: values}
  });
}

function addMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

function setDatePicker() {
  var locale = document.documentElement.lang || 'en';
  $('.datepicker').datepicker({
    format: 'dd.mm.yyyy',
    autoclose: true,
    todayBtn: 'linked',
    todayHighlight: true,
    orientation: 'bottom',
    weekStart: 1,
    language: locale,
    startDate: '0d'
  });
}
